import API from './api';

// Atlas — read-only macro-warehouse API (MacroSeries + MacroObservation).
// Superuser-only server-side (IsSuperuser). RAW point-in-time values; detectors are downstream.
export const atlasService = {
  // Overview grid: curated signal indicators grouped, each with latest/change/sparkline/percentile.
  getDashboard: () => API.get('/api/trading/macro/dashboard/'),
  // US Treasury yield curve — today + 1M/3M/1Y-ago tenor snapshots + 2s10s slope.
  getCurve: () => API.get('/api/trading/macro/curve/'),
  // Browse tree: buckets → series + each series' latest value.
  getCatalog: () => API.get('/api/trading/macro/catalog/'),
  // One series' current-view observations (+ children). opts: { start, end } (ISO) window the series
  // in the DB before downsampling → native resolution for short ranges.
  getSeries: (code, opts = {}) => API.get('/api/trading/macro/series/', { params: { code, ...opts } }),
  // Layer-2 regime: the hierarchical reality-anchored read (5 axes → weighted concept groups → member
  // series w/ actual value + percentile + robust z + stance + enrichment) + the Growth×Inflation quadrant
  // timeline. Heavy → server caches 24h; pass { refresh: 1 } to force a recompute.
  getRegime: (opts = {}) => API.get('/api/trading/macro/regime/', { params: { ...opts } }),
};

export default atlasService;
